'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components/Heading';

export interface H4Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H4({ children, ...props }: H4Props) {
    return (
        <Heading
            type="h4"
            size="3xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
